// Outro componente onde você deseja utilizar a autenticação
import RegisterComponent from "components/ComponentRegistrar";
import React from "react";

const Register = () => {
  return (
    <div>
      <h1>Pagina de Registro</h1>
      <RegisterComponent />
    </div>
  );
};

export default Register;
